var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 731,
    viewBox: "0 0 1440 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 731,
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1044_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 731
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 731,
    fill: "#1D1D1B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1044_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.921 654.654C239.565 619.741 212.221 588.428 185.599 556.994C135.568 500.126 85.8182 443.098 36.3493 385.91C24.9062 372.345 10.7938 361.258 -5.1176 353.334C-21.029 345.411 -38.4017 340.818 -56.1641 339.84C-81.822 338.28 -107.6 339.84 -136.029 339.84V721C-169.973 708.257 -200.78 688.416 -226.374 662.812C-309.492 579.91 -337.438 480.451 -304.553 368.634C-271.667 256.818 -193.368 188.072 -78.6901 163.957C82.7263 129.884 245.829 246.02 267.03 409.066C269.341 431.904 270.266 454.861 269.801 477.811C270.162 535.039 269.921 592.267 269.921 654.654Z",
    fill: "url(#paint0_linear_1044_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.92 326.654C1508.57 291.741 1481.22 260.428 1454.6 228.994C1404.57 172.126 1354.82 115.098 1305.35 57.9104C1293.91 44.3447 1279.79 33.258 1263.88 25.3343C1247.97 17.4107 1230.6 12.8182 1212.84 11.8401C1187.18 10.2804 1161.4 11.8401 1132.97 11.8401V393C1099.03 380.257 1068.22 360.416 1042.63 334.812C959.508 251.91 931.562 152.451 964.447 40.634C997.333 -71.1825 1075.63 -139.928 1190.31 -164.043C1351.73 -198.116 1514.83 -81.9802 1536.03 81.0656C1538.34 103.904 1539.27 126.861 1538.8 149.811C1539.16 207.039 1538.92 264.267 1538.92 326.654Z",
    fill: "url(#paint1_linear_1044_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.689 878.129V496C445.343 511.6 481.513 536.969 509.992 569.856C587.495 659.564 607.713 762.001 565.111 872.124C522.508 982.247 437.543 1045.05 319.724 1057.54C279.348 1061.59 238.57 1057.18 199.999 1044.6C161.428 1032.02 125.913 1011.55 95.7252 984.485C65.5377 957.425 41.3424 924.376 24.687 887.451C8.03154 850.526 -0.717323 810.539 -1 770.047C-1 706.879 -1 643.712 -1 580.544V563.011L20.181 587.029L228.862 828.771C241.141 843.855 256.569 856.084 274.07 864.609C291.57 873.133 310.723 877.747 330.194 878.129C354.263 878.129 378.333 878.129 404.689 878.129Z",
    fill: "url(#paint2_linear_1044_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.69 550.129V168C1714.34 183.6 1750.51 208.969 1778.99 241.856C1856.5 331.564 1876.71 434.001 1834.11 544.124C1791.51 654.247 1706.54 717.055 1588.72 729.544C1548.35 733.59 1507.57 729.181 1469 716.601C1430.43 704.021 1394.91 683.545 1364.73 656.485C1334.54 629.425 1310.34 596.376 1293.69 559.451C1277.03 522.526 1268.28 482.539 1268 442.047C1268 378.879 1268 315.712 1268 252.544V235.011L1289.18 259.029L1497.86 500.771C1510.14 515.855 1525.57 528.084 1543.07 536.609C1560.57 545.133 1579.72 549.747 1599.19 550.129C1623.26 550.129 1647.33 550.129 1673.69 550.129Z",
    fill: "url(#paint3_linear_1044_9)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_9",
    x1: 31.6513,
    y1: 566.472,
    x2: -270.518,
    y2: -66.8652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#267A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2A7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4C942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#66A629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#78B326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#83BA25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#87BD24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1044_9",
    x1: 1300.65,
    y1: 238.472,
    x2: 998.482,
    y2: -394.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#267A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2A7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4C942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#66A629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#78B326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#83BA25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#87BD24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1044_9",
    x1: 335.971,
    y1: 823.968,
    x2: 753.771,
    y2: 1372.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C01718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C71817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D71A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E11B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E41B14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1044_9",
    x1: 1604.97,
    y1: 495.968,
    x2: 2022.77,
    y2: 1044.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C01718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C71817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D71A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E11B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E41B14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBg);
export default __webpack_public_path__ + "static/media/Black BG.79ef60dc1300f8947fb593f5b49bfbac.svg";
export { ForwardRef as ReactComponent };